import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
const options = [
  { id: 0, label: "Absent", value: 0 },
  { id: 1, label: "Half Day", value: 0.5 },
  { id: 2, label: "Present", value: 1 },
];
const AttendanceInput = ({
  row,
  employeeCode,
  useFormData,
  showDetails,
  dispatch,
}) => {
  const { register, control, setValue, getValues, watch } = useFormData;

  return (
    <>
      {/* <input
        input="text"
        {...register(`attendance[${employeeCode}].attendanceValue[${row}]`)}
        className="form-control"
        style={{ width: "70px" }}
      /> */}
      <Controller
        name={`attendance[${employeeCode}].attendanceValue[${row}]`}
        defaultValue={Number(
          watch(`attendance[${employeeCode}].attendanceValue[${row}]`)
        )}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            className="select"
            options={options}
            placeholder="Attendance"
            value={options.find(
              (option) =>
                option.value ===
                Number(
                  watch(`attendance[${employeeCode}].attendanceValue[${row}]`)
                )
            )}
            onChange={(e) => {
              dispatch({
                type: "CHOOSE_ATTENDANCE",
                data: {
                  row: row,
                  id: employeeCode,
                  value: e.value,
                },
              });
            }}
            menuPortalTarget={document.body}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                fontSize: "10px",
                width: "100px",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 999999,
              }),
            }}            
          />
        )}
      />
      <div style={{ display: `${showDetails === true ? "" : "none"}` }}>
        <input
          type="time"
          {...register(`attendance[${employeeCode}].attendanceInTime[${row}]`)}
          className="form-control attendance-input"
          style={{ width: "100px" }}
          onChange={(e) => {
            dispatch({
              type: "INTIME_CHANGE",
              data: {
                row: row,
                id: employeeCode,
                value: e.target.value,
              },
            });
          }}
        />

        <input
          type="time"
          {...register(`attendance[${employeeCode}].attendanceOutTime[${row}]`)}
          className="form-control attendance-input"
          onChange={(e) => {
            dispatch({
              type: "OUTTIME_CHANGE",
              data: {
                row: row,
                id: employeeCode,
                value: e.target.value,
              },
            });
          }}
          style={{ width: "100px" }}
        />

        <input
          type="text"
          {...register(`attendance[${employeeCode}].totalHours[${row}]`)}
          defaultValue={watch(`attendance[${employeeCode}].totalHours[${row}]`)}
          className="form-control attendance-input"
          style={{ width: "100px" }}
          readOnly={true}
        />
      </div>
    </>
  );
};

AttendanceInput.propTypes = {
  row: PropTypes.number.isRequired,
  employeeCode: PropTypes.number.isRequired,
  useFormData: PropTypes.object.isRequired,
  showDetails: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default AttendanceInput;
